import { Component, OnInit, HostListener, HostBinding, ChangeDetectorRef, OnDestroy, ViewChild, ElementRef, AfterContentChecked } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  Router,
  ActivatedRoute,
  RouterEvent,
  NavigationStart,
  NavigationEnd,
  NavigationError,
  NavigationCancel,
  GuardsCheckStart,
  GuardsCheckEnd
} from '@angular/router';

import { BreadcrumbsService } from './core/breadcrumb/breadcrumbs.service';
import { UserSession } from '@mem-shared/user-session';
// import { SiteMapItem, getSiteMapModel } from '@mem-shared/site-map/site-map-model';
// import { SiteMapService } from '@mem-shared/site-map/site-map.service';
import { MemberAuditService } from '@mem-shared/audit/member-audit.service';
import { stateNameMap } from './state-name-map';
// import { SessionOutService } from 'app/session-out/session-out.service';
// import { OutageService } from 'app/outage/outage.service';
// import { AlertsService } from '@mem-shared/alerts/alerts.service';
import { EventService } from '@mem-shared/event.service';
import { AppStartupService } from './app-startup.service';
// import { GlobalLoggingService } from './shared/frontend-error-logging/global.logging.service';
// import { BrowserTitleService } from '@mem-shared/browser-title.service';
import { Subscription } from 'rxjs/Subscription';
import { UtilService } from '@mem-shared/util.service';
import { UpdateLobService } from '@mem-shared/update-lob.service';
// import { OnlineChatService } from '@mem-shared/online-chat/online-chat.service';
// import { CfTourUtilityService } from '@mem-shared/cf-tour-utility.service';
const url = "/carefirst-resources/scripts/GDPR-cookie-consent-message-1.js";

@Component({
  selector: 'mem-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [AppStartupService]
})
export class AppComponent implements OnInit, OnDestroy ,AfterContentChecked{
  // megaMenuModel: SiteMapItem[];
  isAuthenticated = false;
  loadAPI: Promise<any>;
  /**
   * see host listeners below. if this value
   * is set to true we will show the outline on
   * buttons else we will hide it.
   */
  acessabilityOutline: boolean;

  /**
   * Keeps track of if a page is loading.
   */
  pageLoading: boolean;

  // for temp hack in ngOninit
  headerHeight;

  /**
   * Previous & current URL. For storing the
   * previous URL in user session.
   */
  currentUrl: string; 
  lob: string;
  previousUrl: string;
  subscription: Subscription;
  page_Title: string;
  private msRouteMap = [];
  @ViewChild('pageTitle') sc_elem: ElementRef;
  constructor(
    private translate: TranslateService,
    private updateLobService: UpdateLobService,
    private activatedroute: ActivatedRoute,
    private breadcrumbsService: BreadcrumbsService,
    public userSession: UserSession,
    // private siteMapService: SiteMapService,
    private memberAuditService: MemberAuditService,
    public route: Router,
    // public outageService: OutageService,
    // private alertSvc: AlertsService,
    private eventSvc: EventService,
    // private sessionOutService: SessionOutService, // Do not remove this line, it used to initialize the service
    // private browserTitleService: BrowserTitleService, // Do not remove this line, it used to initialize the service
    // private globalLoggingService: GlobalLoggingService, // Do not remove this line, it used to initialize the service
    private appStartupService: AppStartupService,
    private utilSvc: UtilService,
    private cdref: ChangeDetectorRef
    // private chatService: OnlineChatService,
    // private cfTourUtility:CfTourUtilityService
  ) {
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('en');

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use('en');

    // set default breadcrumbs
    this.breadcrumbsService.storePrefixed({ label: 'Home', url: '/landing', params: [] });
  }

  // When user goes to a new page, scroll to top first.
  scrollToTop() {
    // don't scroll back up when toggling the tabs as its annoying
    if (
      (this.currentUrl === '/claims/listing/claims' && this.previousUrl === '/claims/listing/eob') ||
      (this.currentUrl === '/claims/listing/eob' && this.previousUrl === '/claims/listing/claims')
    ) {
      return;
    }

    if (window) {
      window.scrollTo(0, 0);
    }
  }

  /**
   * Route Activated
   * Called when a new route is loaded
   */
  routeActivated() {
    this.scrollToTop();
    /**
     * CheckOutage called on route activated to check whether outage has occured
     */
    if (
      !this.route.url.endsWith('outage') &&
      (this.userSession.getCookie('CF-IMPS') === undefined ||
        this.userSession.getCookie('CF-IMPS') === '')
    ) {
      //  this.outageService.checkOutage().subscribe();
    }
    if (stateNameMap.get(this.route.url)) {
      this.memberAuditService.audit('SITENAV', true, '0000', {
        stateName: stateNameMap.get(this.route.url)
      });
    }
  }
  

  ngOnInit() {
      this.userSession.onDataLoaded(isLoaded => {
      this.isAuthenticated = isLoaded;
      if (isLoaded) {
        if (this.userSession.getMemberFeatureFlags().showCareSelect) {
          this.userSession.getMemberFeatureFlags().showFindMyProviders = false;
        }
        
        // set the site map for megamenu based on feature flags
        //  this.megaMenuModel = this.siteMapService.getEnabledFeatures(getSiteMapModel());

        //-------
        // this.megaMenuModel.forEach(item => {
        //   if (item.children){
        //     item.children.forEach(child => {
        //       if (child.children) {
        //         child.children.forEach(grandChild => {
        //           this.msRouteMap.push(grandChild);  
        //         })
        //       }
        //       else {
        //         this.msRouteMap.push(child);
        //       }
        //     });
        //   }
        //   else {
        //     this.msRouteMap.push(item);
        //   }
        // })
        //--------

        //   this.alertSvc.getAlertCount().subscribe(data => {
        //     this.alertSvc.alertCount = data.alertCount;
        //   },
        //   error => {
        //     this.alertSvc.alertCentreDown = true;
        //  });

        // App startup service init
        this.appStartupService.init();
      }

      // the current route
      this.currentUrl = this.route.url;
    });

    // hack until a proper layout component is created. For example
    // angualar.io site has various components for the core app
    // layout to encapuslate complex layout functionality such
    // as this.
    this.subscription = this.eventSvc.subscribe('HEADER_HEIGHT', height => {
      this.headerHeight = height + 'px';
    });

    /**
     * Loading Functionality
     */
    this.route.events.subscribe((event: RouterEvent) => {
      /* if (event instanceof NavigationStart) {
        this.pageLoading = true;
      } */

      if (event instanceof NavigationStart) {
        if (!this.route.navigated) {
          // to hide the chatbox on refreshing and opening url in another tab
          // this.chatService.chatvisible = 'false';
        }
      }

      if (event instanceof GuardsCheckEnd) {
        this.pageLoading = true;
      }
      // stop loading if guard check is in progress
      // this is to allow a modal or something to show
      // as part of guard
      if (event instanceof GuardsCheckStart) {
        // this.pageLoading = false;
      }

      // start loading if guard check done
      /* if (event instanceof GuardsCheckEnd) {
        this.pageLoading = true;
      } */

      // Set loading state to false in both of the below events to hide the spinner in case a request fails
      if (event instanceof NavigationCancel) {
        this.pageLoading = false;
      }

      if (event instanceof NavigationError) {
        this.pageLoading = false;
      }

      // previousURL support for userSession
      if (event instanceof NavigationEnd) {
        this.pageLoading = false;
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
        if (this.msRouteMap) {
          let pageTitleObj = this.msRouteMap.find(data => {
            return data.route == this.currentUrl;
          });
          this.page_Title = pageTitleObj && pageTitleObj.title;
          if (this.page_Title && this.sc_elem) {
            this.sc_elem.nativeElement.focus();
          }


        }
      }
      this.userSession.setSession('previousUrl', this.previousUrl);
    });
    
      //To get the lob value from storage - setting to MEMBER as default if empty
    //   if (this.userSession.getLocalStorageItem('lob') == 'CHPDC' || this.userSession.getLocalStorageItem('lob') == 'CHPMD' ||
    //   this.userSession.getLocalStorageItem('lob') == 'DSNP' || this.userSession.getLocalStorageItem('lob') == 'VAEX' || this.userSession.getLocalStorageItem('lob') == 'EGWP'||
    //   this.userSession.getLocalStorageItem('lob') == 'MAPD' || this.userSession.getLocalStorageItem('lob') == 'MHBE') {
    //   this.lob = this.userSession.getLocalStorageItem('lob');
    // } else {
    //   this.lob = 'MEMBER';
    // }
    // To resolve cache issue for okta login widget - setting lob from service
    this.updateLobService.lobSrc.subscribe(response => {this.lob = response; });
  }
  ngAfterContentChecked() {
    this.cdref.detectChanges();
     }

  /**
   * Acessability Outline Control
   * UX team has avised to only show the acessability outline
   * when the "tab" key is clicked. Then hide it again when user
   * click on page. I do not agree with this but need to close
   * the defect then try to work on another approach with Bryan.
   *
   * Note: I tried to turn this into a directive but this needs to
   * be on the host app-root element. We cannnot create a child
   * element in app.html since it will break the megamenu flex
   * layut. Ideally it would be possible to bind a directive
   * to the host but that is not possible yet:
   * https://github.com/angular/angular/issues/8785
   */
  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    // if user is interacting with keyboard show the outline
    this.acessabilityOutline = true;
  }

  @HostListener('document:click', ['$event'])
  handleClickEvent(event) {
    // if user is interacting with mouse hide the outline
    this.acessabilityOutline = false;
  }

  @HostListener('document:mousedown', ['$event'])
  handleMousedownEvent(event) {
    // if user is interacting with mouse hide the outline
    this.acessabilityOutline = false;
  }

  @HostBinding('class.acessability-outline')
  get showOutline() {
    return !this.acessabilityOutline;
  }

  ngOnDestroy() {
    this.userSession.setLocalStorageItem('hideslider', true, { persist: true });

    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  skipToMainContent() {
    this.utilSvc.scrollTo('#maincontent');
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts